import EmployeesAPI, { Employee } from "../api/EmployeesAPI";

/**
 * Active sales representatives for dropdowns. When editing an existing record,
 * includes the currently assigned employee even if they are inactive (so the
 * select can display the saved value).
 */
export async function loadSalesRepresentativesForSelect(
  selectedEmployeeId?: string | null
): Promise<Employee[]> {
  const response = await EmployeesAPI.getSalesRepresentatives();
  const employees = response.data ?? [];

  if (!selectedEmployeeId) {
    return employees;
  }

  const selectedId = String(selectedEmployeeId);
  if (employees.some((e) => e.id != null && String(e.id) === selectedId)) {
    return employees;
  }

  const numericId = Number(selectedEmployeeId);
  if (!Number.isFinite(numericId)) {
    return employees;
  }

  try {
    const one = await EmployeesAPI.getById(numericId);
    if (one.data?.id != null) {
      return [...employees, one.data];
    }
  } catch (error) {
    console.error("Failed to load assigned sales representative for select", {
      selectedEmployeeId,
      error,
    });
  }

  return employees;
}
